import { PageHeader, OwnerNote } from "../components/Layout";

const SECTIONS = [
  ["Uafhængig", "VetPris er en selvstændig prisportal uden tilknytning til dyreklinikker, kæder eller forsikringsselskaber. Vi tager ikke betaling for placeringer."],
  ["Gennemskuelig", "Hver pris er markeret som fast pris, fra-pris eller estimat og vises med betingelser, kilde og verificeringsstatus."],
  ["Verificeret", "Priser kan være bekræftet af klinikken selv, verificeret af VetPris, ikke verificeret eller markeret som forældede."],
  ["Ansvarlig dataindsamling", "Priser hentes kun fra klinikkernes egne prislister, når kilden er godkendt, eller indsendes af klinikken selv. Hver pris kontrolleres før publicering, og vi kopierer ikke data fra andre prissammenligningstjenester."],
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader eyebrow="Om VetPris" title="Overblik over dyrlægepriser – på dyreejerens præmisser">VetPris hjælper hunde- og katteejere med at forstå og sammenligne priser på almindelige dyrlægebehandlinger.</PageHeader>
      <div className="container-vp py-14 grid gap-6 md:grid-cols-2">
        {SECTIONS.map(([t, d]) => (
          <section key={t} className="card-vp p-6"><h2 className="text-xl font-bold text-[#153C3A]">{t}</h2><p className="text-sm text-[#334155] mt-3 leading-relaxed">{d}</p></section>
        ))}
        <section className="md:col-span-2 card-vp p-6" data-testid="about-owner">
          <h2 className="text-xl font-bold text-[#153C3A]">Ejerskab</h2>
          <div className="mt-3"><OwnerNote testid="about-owner-note" /></div>
        </section>
        <section className="md:col-span-2 rounded-xl bg-[#E6F4EF] border border-[#D2E5E1] p-6 text-sm text-[#153C3A]" data-testid="about-phase-notice">
          <h2 className="font-heading font-bold text-base">Dækning</h2>
          <p className="mt-2">VetPris udvider løbende oversigten over klinikker og priser. Ikke alle klinikker har verificerede priser endnu, og den endelige pris skal altid bekræftes hos klinikken.</p>
        </section>
      </div>
    </div>
  );
}
